import type { ReactNode } from "react";
import { Box, SwipeableDrawer } from "@mui/material";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onTransitionEnd?: () => void;
  /** Fires after the close animation completes — safe point to reset content without a visible flash. */
  onClosed?: () => void;
  children: ReactNode;
};

export const BottomDrawer = ({
  isOpen,
  onClose,
  onTransitionEnd,
  onClosed,
  children,
}: Props) => (
  <SwipeableDrawer
    anchor="bottom"
    open={isOpen}
    onClose={onClose}
    onOpen={() => {}}
    onTransitionEnd={() => {
      if (isOpen) {
        onTransitionEnd?.();
      }
    }}
    slotProps={{
      transition: { onExited: onClosed },
      paper: {
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxHeight: "80vh",
          p: 3,
        },
      },
    }}
  >
    <Box maxWidth={600} mx="auto" width="100%">
      {children}
    </Box>
  </SwipeableDrawer>
);
